const RESPONSIVE_SIZES = {
  DESKTOP: 1024,
  TABLETHD: 840,
}

const ADS_INFO = {
  'div-gpt-ad-mobile': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile',
    adSize: [320, 50],
    maxWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-box': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_box',
    adSize: [468, 60],
    1280: [300, 250],
    setTargeting: [['location', ['first']]],
    minWidth: RESPONSIVE_SIZES.DESKTOP,
  },
  'div-gpt-ad-box-1': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_box',
    adSize: [468, 60],
    1280: [300, 250],
    minWidth: RESPONSIVE_SIZES.TABLETHD,
    maxWidth: RESPONSIVE_SIZES.DESKTOP,
  },
  'div-gpt-ad-box-2': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_box_2',
    adSize: [160, 600],
    1280: [300, 250],
    minWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-tower': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_tower',
    adSize: [160, 600],
    minWidth: RESPONSIVE_SIZES.DESKTOP,
  },
  'div-gpt-ad-1528733208433-0': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_tower',
    adSize: [160, 600],
    minWidth: RESPONSIVE_SIZES.DESKTOP,
  },
  'div-gpt-ad-1470951919306-0': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_bottom',
    adSize: [728, 90],
    minWidth: RESPONSIVE_SIZES.DESKTOP,
  },
  'div-gpt-ad-1447089861109-0': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile',
    adSize: [320, 50],
    maxWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-1447090052411-0': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile_2',
    adSize: [320, 50],
    maxWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-1447090103302-0': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile_3',
    adSize: [320, 50],
    maxWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-1447090172253-0': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile_4',
    adSize: [320, 50],
    maxWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-1485190827857-0': {
    adUnitPath: '/3102/priceline.dart/air_fare_results_300x600',
    adSize: [160, 600],
    1280: [300, 600],
    minWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-1572965562221-0': {
    adUnitPath: '/3102/priceline.dart/air_search_results_branded_filter',
    minWidth: RESPONSIVE_SIZES.TABLETHD,
    maxWidth: RESPONSIVE_SIZES.DESKTOP,
  },
  'div-gpt-ad-1771612541369-0': {
    adUnitPath: '/3102/priceline.dart/air_search_results_branded_filter_mweb',
    adSize: 'Fluid',
    maxWidth: RESPONSIVE_SIZES.TABLETHD,
  },
  'div-gpt-ad-1621948623733-0': {
    adUnitPath: '/3102/priceline.dart/priceline_flight_cpc_inline',
    adSize: 'fluid',
  },
  'div-gpt-ad-1774275433713-0': {
    adUnitPath: '/3102/priceline.dart/priceline_flight_inline_slot_2',
    adSize: 'fluid',
  },
}

export { ADS_INFO }
